import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardMeasuresEdit = guard(groupRights.Measures)('edit')
export const guardMeasuresWatch = guard(groupRights.Measures)('watch')
export const guardMeasuresCreate = guard(groupRights.Measures)('create')

